export default __webpack_public_path__ + "93062f83bff0c00b411a5411ccdcaab3.png";